// extracted by mini-css-extract-plugin
module.exports = {"bar":"_5D3XtM0t","header":"_5D1pbZfW","main":"_5D2kpeEY","description":"_5D1Xs0sF","team-members":"_5D1QKwS9","title":"_5D1slT5V","search":"_5D20vHgs","modal":"_5Dv8nE8w"};